module.exports = __webpack_public_path__ + "img/about.9e96c644.jpg";